import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

/**
 * Whether the brand frames price watch as saving to "My list". Every reframed
 * surface reads this one hook, so the framing stays in step across them. The
 * mobile AP toggle is the one exception: it holds its label on alert wording,
 * while everything else on it, its own icon included, still follows this hook.
 */
export const useIsSaveFraming = () => {
  const {retention} = useBrandCapabilities()

  return Boolean(retention?.hasMyListFraming)
}
